import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, useClassnames, Text, Title, Button } from '@wb-tech/ui-react';

import { useNotification } from '#hook/use-notification';
import OfferPDF from '#assets/docs/wildberries-campaigns-offer.pdf';
import OfferPDFZh from '#assets/docs/wildberries-campaigns-offer-zh.pdf';
import { api } from '#adapter/api/campaigns';
import { useLanguage } from '#hook/use-language';
import { useSupplierFetch } from '#hook/use-supplier-fetch';

import style from './index.module.pcss';

export const OfferModal = () => {
    const cn = useClassnames(style);
    const { t } = useTranslation();

    const { methods } = useNotification();

    const { isSpecial, contractId } = useSupplierFetch();
    const [triggerCreateContract] = api.endpoints.v3ContractPost.useMutation();

    const { isZH } = useLanguage();

    const offer = isZH ? OfferPDFZh : OfferPDF;

    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        if(contractId === 0 && !isSpecial) {
            setIsOpen(true);
        }
    }, [contractId, isSpecial]);

    const onClick = () => {
        triggerCreateContract()
            .unwrap()
            .then(() => methods.success(t('components.offer-modal.confirmed')))
            .catch(() => methods.error(t('components.offer-modal.error')));
        setIsOpen(false);
    };

    return (
        <Modal
            widthPreset="xl"
            isOpen={isOpen}
            className={{
                'modal__body'    : cn('offer-modal__body'),
                'modal__children': cn('offer-modal__children')
            }}
            isCloseIconShow={false}
            header={(
                <Title
                    tagName="h3"
                    children={t('components.offer-modal.title')}
                />
            )}
        >
            <div className={cn('offer-modal__info')}>
                <object
                    data={offer}
                    type="application/pdf"
                    width="100%"
                    height="100%"
                    className={cn('offer-modal__pdf')}
                >
                    <a href={offer}>
                        <Text>{t('components.offer-modal.title')}</Text>
                    </a>
                </object>
                <Button
                    presetStyle="primary"
                    onClick={onClick}
                    className={cn('offer-modal__btn')}
                >
                    {t('components.offer-modal.button')}

                </Button>
            </div>
        </Modal>
    );
};
